import React from 'react';
import ReactDom from 'react-dom';
import AppProvider from './components/app/app-provider';

ReactDom.render(<AppProvider />, document.getElementById('widget-ReactClientWidget'));
